<template>
  <BaseDataList ref="dataList" :items="projects" :service="fetchProjects">
    <template #header>
      <ProjectListHeader />
    </template>

    <template #default="{ item }">
      <ProjectListItem :product-id="productId" :project="item" @project-removed="refreshList" />
    </template>
  </BaseDataList>
</template>

<script>
import { productProjectsClient } from '@/api/clients/admin';
import mapKeysToCamelCase from '@/utils/map-keys-to-camel-case';
import ProjectListHeader from './ProjectListHeader.vue';
import ProjectListItem from './ProjectListItem.vue';

export default {
  components: {
    ProjectListHeader,
    ProjectListItem,
  },
  props: {
    productId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      projects: [],
    };
  },
  methods: {
    refreshList() {
      this.$refs.dataList.resetList();
      this.$emit('change');
    },
    async fetchProjects() {
      try {
        const response = await productProjectsClient.list(this.productId);

        this.projects = response.data.map(mapKeysToCamelCase);

        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
